import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiCall from "../../api/api-call";
import ApplyJob from "./ApplyJob";
import CompanyDetailSidebar from "./CompanyDetailSidebar";
import JobSummarySidebar from "./JobSummarySidebar";

function JobDetailSection() {
  const [details, setDetails] = useState(null);
  const { jobid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let queryParam = new URLSearchParams();
    queryParam.append("jobid", jobid);

    apiCall
      .getJobDetails(queryParam.toString())
      .then((response) => {
        //console.log("response: ", response);
        if (response.data.response.Items.length) {
          setDetails(response.data.response.Items[0]);
        } else {
          navigate("/404-page");
        }
      })
      .catch((error) => console.log("error: ", error));
  }, [jobid, navigate]);

  return (
    <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        {!details ? (
          <p>Loading...</p>
        ) : (
          <div className="row gy-5 gx-4">
            <div className="col-lg-8">
              <div className="d-flex align-items-center mb-5">
                <img
                  className="flex-shrink-0 img-fluid border rounded"
                  src={`https://picsum.photos/seed/${Math.random()}/80`}
                  alt=""
                  style={{ width: "80px", height: "80px" }}
                />
                <div className="text-start ps-4">
                  <h3 className="mb-3">{details.title}</h3>
                  <span className="text-truncate me-3">
                    <i className="fa fa-map-marker-alt text-primary me-2"></i>
                    {details.location}
                  </span>
                  <span className="text-truncate me-3">
                    <i className="far fa-clock text-primary me-2"></i>
                    {details.jobNature}
                  </span>
                  <span className="text-truncate me-0">
                    <i className="far fa-money-bill-alt text-primary me-2"></i>
                    {details.salary}
                  </span>
                </div>
              </div>

              <div className="mb-5">
                <h4 className="mb-3">Job description</h4>
                <p style={style.prewrap}>{details.description}</p>
              </div>

              <ApplyJob jobPostDetails={details} />
            </div>

            <div className="col-lg-4">
              <JobSummarySidebar details={details} />
              <CompanyDetailSidebar details={details} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const style = {
  prewrap: { whiteSpace: "pre-wrap" },
};

export default JobDetailSection;
